import { Flex } from '@abyss/web/ui/Flex';
import { Heading } from '@abyss/web/ui/Heading';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Text } from '@abyss/web/ui/Text';
import { useTranslation } from 'react-i18next';

export interface Props {
  handleBackButton: () => void;
  handleCrossButton: () => void;
  headingTitle?: string;
}

export const SmartChoiceBreakDownWidgetHeader = ({
  handleBackButton,
  handleCrossButton,
  headingTitle,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex
        alignItems="center"
        css={{
          padding: '16px',
        }}
        justify="space-between"
      >
        <Flex
          alignItems="center"
          css={{
            cursor: 'pointer',
          }}
          data-testid="widget-back-button"
          onClick={handleBackButton}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleBackButton();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <IconMaterial
            color="$interactive1"
            css={{
              'abyss-icon-material': {
                marginRight: '8px',
              },
            }}
            icon="arrow_back"
            size="16px"
            title="Back"
          />
          <Text color="$interactive1" fontWeight="$bold">
            {t('BACK')}
          </Text>
        </Flex>
        <IconMaterial
          color="$interactive1"
          css={{
            cursor: 'pointer',
          }}
          data-testid="widget-cross-icon"
          icon="close"
          onClick={handleCrossButton}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleCrossButton();
            }
          }}
          role="button"
          size="24px"
          tabIndex={0}
          title="Close"
        />
      </Flex>
      <Heading
        css={{
          fontSize: '32.43px !important',
          lineHeight: '40px !important',
          padding: '0 16px 0px 16px',
        }}
        data-testid="smart-choice-widget-heading"
      >
        {headingTitle}
      </Heading>
    </>
  );
};
